import { takeLatest, put, call, select, debounce } from 'redux-saga/effects';
import {
    GET_CLIENTS_REQUEST,
    GET_TYPING_CLIENTS_REQUEST,
    getClientsSuccess,
    getClientsFailure,
    SUBMIT_CLIENT_REQUEST,
    submitClientsSuccess,
    submitClientsFailure,
    GET_CLIENT_REQUEST,
    getClientSuccess,
    getClientFailure
} from '../actions/clients';
import { getClients, postClients, putClients } from '../services/clients';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getProfilesWorker } from '../../profiles/sagas/profiles';
import { profilesSelector } from '../../profiles/selectors/profiles';

export const getClientsWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);
        const profileAccount_id = yield call(getAccountProfile);

        const { data } = yield call(getClients, filters, token, profileAccount_id);

        // NOTE: same backend inconsistency as getClientWorker below — normalize either shape.
        const users = Array.isArray(data) ? data : (data.users || []);
        const total = Array.isArray(data) ? users.length : data.total;

        const { profiles } = yield select(profilesSelector);

        yield put(getClientsSuccess(users, total, profiles));
    } catch (err) {
        yield put(getClientsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export const getClientWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const { data } = yield call(getClients, filters, token);

        // NOTE: the backend has been seen returning either { users: [...] } or a bare [...] array
        // for this same endpoint — normalize both instead of assuming one shape.
        const users = Array.isArray(data) ? data : (data.users || []);

        const { profiles } = yield select(profilesSelector);

        yield put(getClientSuccess(users[0] || {}, profiles));
    } catch (err) {
        console.log(err);
        yield put(getClientFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitClientsWorker = function* ({ payload: { client }, history }) {
    try {
        const token = yield select(accessTokenSelector);

        let respClient = { ...client };

        if (!client._id) {
            const profileAccount_id = yield call(getAccountProfile);

            const { data: { user } } = yield call(postClients, client, profileAccount_id, token);

            respClient = { ...user };
            yield put(showGlobalError(true, 200, 'created'));

        } else {
            const {data:{user}} = yield call(putClients, client, token);
            respClient = {...user}
            yield put(showGlobalError(true, 200, 'updated'));
        }
        yield put(submitClientsSuccess(respClient));

    } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 409) {
            yield put(showGlobalError(true, 409, 'user_already_exist'));
        } else {
            yield put(showGlobalError(true, err));
        }
        yield put(submitClientsFailure(err));
    }
};

export const getAccountProfile = function* () {
    try {
        yield call(getProfilesWorker);
        const { profiles } = yield select(profilesSelector);
        return profiles.find(profile => profile.code === 'account')._id;
    } catch (error) {
        throw error;
    }
};

export default [
    debounce(500, GET_TYPING_CLIENTS_REQUEST, getClientsWorker),
    takeLatest(GET_CLIENTS_REQUEST, getClientsWorker),
    takeLatest(GET_CLIENT_REQUEST, getClientWorker),
    takeLatest(SUBMIT_CLIENT_REQUEST, submitClientsWorker)
];
